export default "__VITE_ASSET__CFgK8z4E__"